// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

class AddHangTag extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...this.props}>
                <circle cx="16.5" cy="7.5" r="1.5" />
                <path d="M10,22.8c-1.1,0-2.1-0.4-2.8-1.2l-4.8-4.8c-0.8-0.8-1.2-1.8-1.2-2.8c0-1.1,0.4-2.1,1.2-2.8l8.8-8.8c0.9-0.9,2.1-1.3,3.3-1.1l4.2,0.5c1.8,0.2,3.2,1.7,3.5,3.5l0.5,4.2c0.2,1.2-0.3,2.4-1.1,3.3l-8.8,8.8C12.1,22.3,11.1,22.8,10,22.8zM14.1,3.2c-0.5,0-1,0.2-1.4,0.6l-8.8,8.8C3.5,13,3.2,13.5,3.2,14s0.2,1,0.6,1.4l4.8,4.8c0.8,0.8,2.1,0.8,2.8,0l8.8-8.8c0.4-0.4,0.6-1,0.6-1.7l-0.5-4.2c-0.1-0.9-0.8-1.6-1.7-1.7l-4.2-0.5C14.2,3.2,14.2,3.2,14.1,3.2z" />
            </SvgIcon>
        );
    }
}

export default AddHangTag;
